// Which button dismissing the dialog, by backdrop click or escape, stands in for.
export type ConfirmDialogDismissAction = 'cancel' | 'confirm' | 'secondOption';

export class ConfirmDialogData {
  cancelText = "";
  confirmText = "";
  secondOptionText?: string | undefined;
  secondOptionActionIcon?: string | undefined;
  actionIcon = "";
  actionColour = "";
  message = "";
  title = "";
  dismissAction?: ConfirmDialogDismissAction;
}
